import { EyeOutlined } from '@ant-design/icons';
import { Link } from '@framework/ui/core/router/TypedRoute.tsx';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { getSubmissionPath } from './getSubmissionPath.ts';

export interface ISubmissionViewTableButtonProps {
  submissionId?: string | null;
  isMobile?: boolean | null;
}

/**
 * Pulsante "visualizza il dettaglio della richiesta" all'interno della tabella delle richieste
 */
export function SubmissionViewTableButton(
  props: ISubmissionViewTableButtonProps,
) {
  const { submissionId, isMobile } = props;

  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Link
      title={t(
        'submission-list.apri-pagina-dettaglio-richiesta',
        'Apri la pagina di dettaglio della richiesta',
      )}
      to={getSubmissionPath(theme.redirectToFirstModule, submissionId)}
    >
      <Tooltip
        title={t(
          'submission-list.visualizza-richiesta',
          'Visualizza richiesta',
        )}
      >
        <EyeOutlined
          aria-hidden={!isMobile}
          aria-label={t(
            'submission-list.visualizza-richiesta',
            'Visualizza richiesta',
          )}
        />
      </Tooltip>
    </Link>
  );
}
